webpackJsonp([70144966829960],{

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactForm = function (_Component) {
	  _inherits(ContactForm, _Component);
	
	  function ContactForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ContactForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { submitted: false }, _this.handleSubmit = function (e) {
	      _this.setState({ submitted: true });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ContactForm.prototype.render = function render() {
	    if (this.state.submitted) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          {
	            key: 0,
	            className: 'tracked-tight f-headline lh-solid mb0 tc'
	          },
	          'Thanks!'
	        ),
	        _react2.default.createElement(
	          'p',
	          {
	            key: 1,
	            className: 'georgia f4-ns lh-copy tc'
	          },
	          'We\'ll be in touch shortly.'
	        )
	      );
	    }
	    return _react2.default.createElement(
	      'form',
	      {
	        method: 'POST',
	        action: 'https://formspree.io/rongierlach@gmail.com',
	        onSubmit: this.handleSubmit
	      },
	      _react2.default.createElement(
	        'label',
	        { className: 'f6 b db mb2' },
	        'Name ',
	        _react2.default.createElement(
	          'span',
	          { className: 'normal black-60' },
	          '(optional)'
	        )
	      ),
	      _react2.default.createElement('input', {
	        name: 'name',
	        type: 'text',
	        className: 'outline-0 input-reset ba b--black-20 pa2 mb2 db w-100 br0 georgia',
	        autoFocus: true
	      }),
	      _react2.default.createElement(
	        'label',
	        { className: 'f6 b db mb2' },
	        'Email'
	      ),
	      _react2.default.createElement('input', {
	        required: true,
	        name: 'email',
	        type: 'email',
	        className: 'outline-0 input-reset ba b--black-20 pa2 mb2 db w-100 br0 georgia'
	      }),
	      _react2.default.createElement(
	        'label',
	        { className: 'f6 b db mb2' },
	        'Message'
	      ),
	      _react2.default.createElement('textarea', {
	        required: true,
	        name: 'message',
	        className: 'input-reset outline-0 border-box ba b--black-20 pa2 mb3 br0 db w-100 h4 mw-100 georgia'
	      }),
	      _react2.default.createElement(
	        'button',
	        {
	          type: 'submit',
	          className: 'button-reset link pointer tracked sans-serif f4 b pa2 mb3 w-100 ttu bw3 br0 near-white hover-gold bg-near-black b--solid b--near-black hover-bg-near-black'
	        },
	        'Submit'
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react.Component);
	
	exports.default = ContactForm;
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  head: {
	    title: 'Contact',
	    meta: [{ name: 'description', content: 'This is a contact form.' }],
	    links: [{ rel: 'canonical', href: 'https://youfoundron.com/contact' }]
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contact = __webpack_require__(226);
	
	var _Head = __webpack_require__(55);
	
	var _Head2 = _interopRequireDefault(_Head);
	
	var _Container = __webpack_require__(21);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _FadeInUp = __webpack_require__(27);
	
	var _FadeInUp2 = _interopRequireDefault(_FadeInUp);
	
	var _ContactForm = __webpack_require__(213);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage() {
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(_Head2.default, _contact.head),
	    _react2.default.createElement(
	      _FadeInUp2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        { className: 'pv5 center measure' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'sans-serif' },
	          'Contact'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_ContactForm2.default, null)
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-a486682b4d83cb6d5284.js